import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '@/shared/ui';

import { templateEditorMessages } from '../../config';
import { EditorButton } from '../EditorButton';

import styles from './AiOptionRow.module.scss';

type AiOptionRowProps = {
  displayNumber: string;
  readOnly?: boolean;
  className?: string;
  onDelete: () => void;
};

export const AiOptionRow: FC<AiOptionRowProps> = (props) => {
  const { displayNumber, readOnly, className, onDelete } = props;

  const { formatMessage } = useIntl();

  return (
    <div
      className={cn(styles.row, className)}
      data-component="template-ai-option-row"
    >
      <span className={cn('p4', styles.number)}>{displayNumber}</span>
      <span className={cn('p3', styles.text)}>
        {formatMessage(templateEditorMessages.aiOptionRowText)}
      </span>
      <span className={styles.iconPlaceholder} />
      {readOnly ? (
        <span className={styles.iconPlaceholder} />
      ) : (
        <EditorButton
          variant="icon"
          className={styles.deleteButton}
          title={formatMessage(templateEditorMessages.deleteAiOption)}
          onClick={onDelete}
        >
          <Icon name="delete" size={18} />
        </EditorButton>
      )}
    </div>
  );
};
